import { useMutation } from "@tanstack/react-query";

import createPrivateAdminPanelInstance from "../../api/PrivateAdminPanelInstance";
import { API_ROUTES } from "../../api/ApiRoutes";

import type { DeleteUserNoteResponse } from "./types";

type StoredToken = {
  AccessToken?: string;
};

export type DeleteUserNotePayload = {
  user_id: string;
  note_id: string;
};

const deleteUserNote = async ({
  user_id,
  note_id,
}: DeleteUserNotePayload): Promise<DeleteUserNoteResponse | null> => {
  const tokenString = localStorage.getItem("token");
  const token: StoredToken | null = tokenString
    ? JSON.parse(tokenString)
    : null;
  const PrivateAdminPanelInstance = createPrivateAdminPanelInstance(
    token?.AccessToken,
  );

  const response = await PrivateAdminPanelInstance.delete(
    API_ROUTES.DELETE_USER_NOTE.replace("{user_id}", user_id).replace(
      "{note_id}",
      note_id,
    ),
  );

  return (response?.data as DeleteUserNoteResponse | undefined) ?? null;
};

export const useDeleteUserNote = () =>
  useMutation<DeleteUserNoteResponse | null, Error, DeleteUserNotePayload>({
    mutationKey: ["deleteUserNote"],
    mutationFn: deleteUserNote,
  });
